/**
 ** this create tour ticket toggle dropdown effect
 *
 * */
import $ from 'jquery';

export	function tourTicketDropDown(){
		
		$(document).ready(function() {
    			localStorage.removeItem("TourTicket");
		});
		
		$(".tourModalValue").on("click", function(e){
				var selItem = $(this);
				var selItemId = selItem.attr('id');
				
				var storeItem = localStorage.getItem("TourTicket");
				
				if(storeItem == null){
					addActiveClass(selItem, selItemId);
                                       
                        	}else{				
					if(storeItem == selItemId){
	                                	removeActiveClass(storeItem);
                           		}else{
						if($('#'+storeItem).hasClass('active')){
        	                                	removeActiveClass(storeItem);
							addActiveClass(selItem, selItemId);
                        	                }else{
                                	                addActiveClass(selItem, selItemId);
                                        	}
					}
				}
				e.stopPropagation();
				
		});
		
		function addActiveClass(selItem, selItemId){
			 selItem.addClass('active');
                         $("#"+selItemId+" .her-ripple-out .dropdown-menu").addClass("open");
                         localStorage.setItem("TourTicket", selItemId);
	       	}
		
		function removeActiveClass(selItemId){
			$("#"+selItemId).removeClass('active');
                        $("#"+selItemId+" .her-ripple-out .dropdown-menu").removeClass("open");
                        localStorage.removeItem("TourTicket");
		}		

}

